import React from "react";
import CountUp from "react-countup";
import { Container, Row, Col } from "react-bootstrap";
import {
  PeopleFill,
  MortarboardFill,
  CurrencyDollar,
  Globe2,
} from "react-bootstrap-icons";
import "./customproduct.scss";

function ClientCount() {
  return (
    <section className="client-count-section">
      <Container fluid>
        <Row className="text-center">

          {/* Total Clients */}
          <Col md={3} sm={6} className="count-box">
            <PeopleFill className="count-icon" />
            <h2>
              <CountUp end={200} duration={3} />+
            </h2>
            <p>Total Satisfied Clients</p>
          </Col>

          {/* School Clients */}
          <Col md={3} sm={6} className="count-box">
            <MortarboardFill className="count-icon" />
            <h2>
              <CountUp end={75} duration={3} />+
            </h2>
            <p>School ERP Clients</p>
          </Col>

          {/* Finance Clients */}
          <Col md={3} sm={6} className="count-box">
            <CurrencyDollar className="count-icon" />
            <h2>
              <CountUp end={60} duration={3} />+
            </h2>
            <p>Finance Application Clients</p>
          </Col>

          {/* Website / Custom */}
          <Col md={3} sm={6} className="count-box">
            <Globe2 className="count-icon" />
            <h2>
              <CountUp end={70} duration={3} />+
            </h2>
            <p>Website / Custom App Clients</p>
          </Col>

        </Row>
      </Container>
    </section>
  );
}

export default ClientCount;
